<script setup>
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import BrandHeader from "./Partials/BrandHeader.vue";
import BrandFooter from "./Partials/BrandFooter.vue";
import DashboardHeader from "./Partials/DashboardHeader.vue";

/**
 * The explore page is public but appears in both the marketing and the
 * logged-in navigation, so the chrome follows the session: guests get the
 * public BrandHeader, members the dashboard header. Content and footer are
 * shared.
 */
const isAuthed = computed(() => !!usePage().props.auth?.user);
</script>

<template>
    <div class="brand min-h-screen bg-brand-cream font-brand text-brand-navy">
        <BrandHeader v-if="!isAuthed" />
        <div v-else class="px-5 pt-5">
            <div class="mx-auto max-w-[1472px]">
                <DashboardHeader />
            </div>
        </div>

        <main>
            <slot />
        </main>

        <BrandFooter />
    </div>
</template>
